(function(angular){
	'use strict';
	
	angular.module('reitServiceModule', [
		'angular.filter', 
		'BaseConfig',
		'bigModule'
	]);

})(window.angular);